import Autocomplete from "@saleor/components/AutocompleteForObject";
import useLocalPaginator, {
  useLocalPaginationState
} from "@saleor/hooks/useLocalPaginator";
import uniqBy from "lodash/uniqBy";
import React, { useEffect, useRef, useState } from "react";

interface IProps {
  handleSelectedSearch?: (value: any) => void;
  value?: string;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  first?: number;
  isClean?: boolean;
  contained: boolean;
  name?: string;
  totalCount?: number;
  getDataSuggestions: any;
  fetchDataSuggestions?: any;
  loadingDataSuggestion: boolean;
  dataOptions: any[];
  error?: boolean;
  searchField: string;
  objectSuggestion?: boolean;
  defaultInputValue?: string;
  defaultValue?: any;
  withNonSelect?: boolean;
  inputValue?: boolean;
  disabled?: boolean;
  pageInfo?: any;
  showLoadMore?: boolean;
  id?: string;
  onMouseLeave?(event: any);
  onClear?(event?: any);
}

interface LastItemParamsProps {
  id: string;
  position: number;
}

const InputSuggestion: React.FC<IProps> = (props: IProps) => {
  const {
    handleSelectedSearch,
    placeholder,
    isClean,
    contained,
    totalCount,
    getDataSuggestions,
    loadingDataSuggestion,
    dataOptions,
    error,
    searchField,
    objectSuggestion,
    onMouseLeave,
    defaultInputValue,
    defaultValue,
    disabled,
    pageInfo,
    showLoadMore,
    id
  } = props;

  const firstRender = useRef(true);
  const [value, setValue] = useState<string>("");
  const [opts, setOpts] = useState<any[]>([]);
  const [
    valuesPaginationState,
    setValuesPaginationState
  ] = useLocalPaginationState(100);
  const paginateValues = useLocalPaginator(setValuesPaginationState);
  const { loadNextPage } = paginateValues(pageInfo, valuesPaginationState);
  const [lastItemParams, setLastItemParams] = useState<LastItemParamsProps>(
    null
  );

  useEffect(() => {
    if (firstRender.current && !value && defaultInputValue && defaultValue) {
      setValue(defaultInputValue);
      firstRender.current = false;
    }
  }, [defaultInputValue, defaultValue, firstRender.current]);

  const handleChange = event => {
    setValue(event);
  };

  const onLastItemVisible = (id: string, position: number) => {
    setLastItemParams({ id, position });
    loadNextPage();
  };

  useEffect(() => {
    if (value?.length >= 2) {
      const filterObj = { first: 100, filter: { [searchField]: value } };
      getDataSuggestions({
        variables: {
          ...filterObj
        }
      });
    }
  }, [value, valuesPaginationState]);

  useEffect(() => {
    const uniqOpts = uniqBy(dataOptions, "value"); // fixd for resolve wrong counting
    setOpts(uniqOpts);
    if (lastItemParams?.id) {
      setTimeout(() => {
        const { id: lastItemId, position } = lastItemParams;
        const el = document.getElementById(lastItemId);
        if (el) {
          el.scrollTo({ top: position });
        }
      }, 100);
    }
  }, [dataOptions]);

  useEffect(() => {
    setLastItemParams(null);
  }, [value]);

  return (
    <div>
      <Autocomplete
        contained={contained}
        defaultInputValue={defaultInputValue}
        optionsProp={opts}
        placeholderProps={placeholder}
        totalCount={opts.length || totalCount}
        onLastItemVisible={showLoadMore && onLastItemVisible}
        onChangeProps={e => {
          handleChange(e);
        }}
        loading={loadingDataSuggestion}
        onSearch={handleSelectedSearch}
        objectSuggestion={objectSuggestion}
        isReset={isClean}
        defaultValue={defaultValue}
        onMouseLeave={onMouseLeave}
        error={error}
        disabled={disabled}
        id={id}
      />
    </div>
  );
};

export default InputSuggestion;
